module.exports = __webpack_public_path__ + "img/Ca-T200.887b2331.gif";